// @ts-check
/**
 * @typedef {"pending" | "success" | "error" | "not-started" | "approved" | "early-retry" | "already-processed"} AddToTranscriptStatus
 */

/** @type {{ [key in AddToTranscriptStatus]: AddToTranscriptStatus }} */
const ALL = {
  'not-started': 'not-started',
  pending: 'pending',
  success: 'success',
  approved: 'approved',
  'already-processed': 'already-processed',
  'early-retry': 'early-retry',
  error: 'error'
};

/** @type {AddToTranscriptStatus} */
const DEFAULT = 'not-started';

/**
 * @returns {AddToTranscriptStatus}
 */
const random = () => {
  return Object.values(ALL)[Math.floor(Math.random() * Object.values(ALL).length)];
};

/**
 *
 * @param {unknown} value
 * @returns {value is AddToTranscriptStatus}
 */
const validator = (value) => {
  return typeof value === 'string' && Object.values(ALL).some((v) => v === value);
};

/**
 *
 * @param {unknown} value
 * @returns {AddToTranscriptStatus}
 */
const fromUnknown = (value) => {
  const cleaned = typeof value === 'string' ? value.trim().toLowerCase() : DEFAULT;
  if (cleaned.includes('not-started')) {
    return 'not-started';
  }
  if (cleaned.includes('pending')) {
    return 'pending';
  }
  if (cleaned.includes('success')) {
    return 'success';
  }
  if (cleaned.includes('approved')) {
    return 'approved';
  }
  if (cleaned.includes('already-processed')) {
    return 'already-processed';
  }
  if (cleaned.includes('early-retry')) {
    return 'early-retry';
  }
  if (cleaned.includes('error')) {
    return 'error';
  }
  return DEFAULT;
};

export const AddToTranscriptStatus = {
  random,
  ALL,
  validator,
  fromUnknown
};
